import React from 'react';
import { Link } from 'react-router-dom';

function GalleryCategoryCard({
  category,
  href,
  previewImage,
  description,
  marker,
  motionStyle,
  onActivate,
  disabled = false,
}) {
  const title = String(category?.title || category?.id || 'Gallery').trim() || 'Gallery';

  return (
    <div className="dse-gallery-category-card-shell" style={motionStyle}>
      <Link
        to={href}
        className={`dse-gallery-category-card${disabled ? ' is-disabled' : ''}`}
        aria-label={`Open ${title} gallery`}
        aria-disabled={disabled ? 'true' : undefined}
        tabIndex={disabled ? -1 : 0}
        onClick={(event) => {
          if (disabled) {
            event.preventDefault();
            return;
          }

          if (typeof onActivate === 'function') {
            const result = onActivate(category, event);
            if (result === false) {
              event.preventDefault();
            }
          }
        }}
      >
        <span className="dse-gallery-category-card__media">
          {previewImage ? (
            <img
              src={previewImage}
              alt={`${title} gallery preview`}
              className="dse-gallery-category-card__image"
              loading="lazy"
              decoding="async"
            />
          ) : (
            <span className="dse-gallery-category-card__placeholder">Preview coming soon</span>
          )}
        </span>

        <span className="dse-gallery-category-card__overlay" aria-hidden />

        <span className="dse-gallery-category-card__content">
          <span className="dse-gallery-category-card__marker" aria-hidden>{marker}</span>
          <span className="dse-gallery-category-card__title">{title}</span>
          <span className="dse-gallery-category-card__description">{description}</span>
          <span className="dse-gallery-category-card__cta">
            View photos
            <span className="dse-gallery-category-card__cta-arrow" aria-hidden> -&gt;</span>
          </span>
        </span>
      </Link>
    </div>
  );
}

export default GalleryCategoryCard;
